import React from 'react';

import { Text } from '../../../storyblocks-design-system/components/atoms/Text/Text';

export const TestimonialAuthor = ({
  name,
  title,
  isHero = false,
}: {
  name: string;
  title?: string;
  isHero?: boolean;
}) => (
  <div
    role="group"
    aria-label="Testimonial author information"
    id={
      isHero
        ? `hero-testimonial-author-${name.replace(/\s+/g, '-').toLowerCase()}`
        : `testimonial-author-${name.replace(/\s+/g, '-').toLowerCase()}`
    }
  >
    <Text
      fontFamily="polysans"
      fontSize="base"
      fontWeight="semibold"
      className="text-gray-900"
    >
      {name}
    </Text>
    {title && (
      <Text
        fontFamily="polysans"
        fontSize="base"
        fontWeight="regular"
        className="text-gray-900"
      >
        {title}
      </Text>
    )}
  </div>
);
